// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"b4382efd","453":"54292a4b","610":"9e920e77","930":"9e2de0d9"}[chunkId] + ".chunk.js";
};